<template>
    <!-- Modal colaboremos -->
	<pm-modal :backgroundColor="'#707070'" :visible="visible" @close="close">
        <template slot="body">
            <div class="row p-0 m-0">
                <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Nombre del contacto</label>
                    <input
                        :class="{ 'is-invalid': $v.colaboremos.nombre.$error }"
                        class="form-control fuente-caja-modal"
                        placeholder="Nombre"
                        ref="nombre"
                        tabindex="101"
                        type="text"
                        v-model="$v.colaboremos.nombre.$model"                        
                        v-focus
                    />
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Tel&eacute;fono</label>
					<div class=" fuente-caja-modal form-inline-block form-inline">
						<span class="form-control fuente-caja-modal">+52</span>
						<cleave
							:class="{ 'is-invalid': $v.colaboremos.telefono.$error }"
							:options="options"
							class="ml-1 form-control fuente-caja-modal d-inline-block d-inline"
							style="border:none;"
							ref="telefono"
							tabindex="102"
							v-model="$v.colaboremos.telefono.$model"
						></cleave>
					</div>
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Correo electr&oacute;nico</label>
                    <input
                        :class="{ 'is-invalid': $v.colaboremos.correo.$error }"
                        class="form-control fuente-caja-modal"
                        placeholder="micorreo@ejemplo.com"
                        ref="correo"
                        tabindex="103"
                        type="text"
                        v-model="$v.colaboremos.correo.$model"
                    />
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Tipo de negocio</label>
                    <input
                        :class="{ 'is-invalid': $v.colaboremos.Negocio.$error }"
                        class="form-control fuente-caja-modal"
                        placeholder="Farmacia / Hospital / Consultorio / Botíca / Otros"
                        ref="Negocio"
                        tabindex="104"
                        type="text"
                        v-model="$v.colaboremos.Negocio.$model"
                    />
                </div>
                <!-- <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Estado</label>
                    
                    <select
                        :class="{ 'is-invalid': $v.colaboremos.estado.$error }"
                        class="form-control fuente-caja-modal text-gray"
                        ref="estado"
                        tabindex="105"
                        v-model="$v.colaboremos.estado.$model"
                    >
                        <option disabled selected value>Seleccione un estado</option>
                        <option
                            :key="index"
                            :value="item.codEstado"
                            v-for="(item, index) in estados"
                        >{{item.descripcion}}</option>
                    </select>
                </div>
                <div class="form-group col-12 col-lg-6">
                    <label class="fuente-label-modal">Municipio</label>
                    <input
                        :class="{ 'is-invalid': $v.colaboremos.municipio.$error }"
                        class="form-control form-control fuente-caja-modal"
                        placeholder="Municipio / Localidad / Delegación"
                        ref="municipio"
                        tabindex="106"
                        type="text"
                        v-model="$v.colaboremos.municipio.$model"
                    />
                </div> -->
                <div class="col-12 text-center">
                    <span
                        @click="enviar"
                        class="link btn btn-block fuente-boton-modal text-white my-3 my-xl-3"
                        tabindex="107"
                    >Enviar</span>
                </div>
            </div>
        </template>
    </pm-modal>
</template>

<script>
import PmModal from "@/components/publica/Modal"
import Cleave from "@/components/publica/Cleave"
import { required, minLength, email } from "vuelidate/lib/validators"	
import servicio from "@/services/servicio-publica"	

export default {
    props:["visible"],
    data(){
        return {
            options: {
                phone: true,
                phoneRegionCode: "MX"
            },
            estados: [],
            colaboremos: {
                nombre: "",
                telefono: "",
                correo: "",
                Negocio: "",
                //estado: "",
                //municipio: ""
            },
        }
    },
    components:{
        PmModal,
        Cleave
    },
    mounted(){
        //this.cargaEstados()
        //this.$nextTick(() => this.$refs.nombre.focus())
    },
    methods:{        
        Inicializa() {
            this.colaboremos = {
                nombre: "",
                telefono: "",
                correo: "",
                Negocio: "",
                //estado: "",
                //municipio: ""
            }
        },
        enviar() { 
            if (!this.colaboremos.nombre) {
                this.$refs.nombre.focus()
            } else if (!this.colaboremos.telefono) {
                this.$refs.telefono.$el.focus()
            } else if (this.$v.colaboremos.correo.$error) {
                this.$refs.correo.focus()
            } else if (!this.colaboremos.Negocio) {
                this.$refs.Negocio.focus()
            } /*else if (!this.colaboremos.estado) {
                this.$refs.estado.focus()
            } else if (!this.colaboremos.municipio) {
                this.$refs.municipio.focus()
            }*/

            this.$v.$touch()
            if (this.$v.$invalid) return

            console.log(this.colaboremos)

            servicio
                .colaboremos(
                    this.colaboremos.nombre,
                    this.colaboremos.telefono,
                    this.colaboremos.correo,
                    this.colaboremos.Negocio,
                    //this.colaboremos.municipio,
                    //this.colaboremos.estado
                )
                .then(r => {
                    //this.visible = false
					this.close()
                    this.$swal.fire({
                        text: r.message,
                        icon: r.value ? "success" : "warning"
                    })
                    this.Inicializa()
                    this.$v.$reset()
                })
                .catch(ex => {
                    console.error(ex)
                })
        },
        cargaEstados() {
            servicio
                .estadosRepublica()
                .then(r => {
                    this.estados = r.data

                    //this.colaboremos.estado='Seleccione un estado'
                    //this.estados.push({codEstado:0, descripcion:'Seleecione un estado'})
                    //this.colaboremos.estado={codEstado:0, descripcion:'Seleecione un estado'}
                    //console.log(this.estados)
                })
                .catch(ex => {
                    console.error(ex)
                })
        },
        close(){
            this.$emit('close')
        }
    },
    validations: {
        colaboremos: {
            nombre: {
                required,
                minLength: minLength(10)
            },
            telefono: {
                required,
                minLength: minLength(10)
            },
            correo: {
                required,
                email
            },
            Negocio: {
                required,
                minLength: minLength(4)
            }/*,
            estado: {
                required
            },
            municipio: {
                required,
                minLength: minLength(4)
            }*/
        }
    }
}
</script>

<style scoped>
.fondo-carro {
		background-image: url("../../assets/img-pub/Difarmer-formulario.png");
		background-size: cover;
		background-repeat: no-repeat;
	}
	.fondo-formulario {
		background-color: var(--color-amarillo);
		opacity: 0.9;
	}
	.fuente-titulo1 {
		font-weight: 600;
	}
	.fuente-titulo3 {
		font-family: "Open Sans", sans-serif;
	}
	.fuente-boton {
		font-family: "Open Sans", sans-serif;
		background-color: var(--color-amarillo) !important;
		border-color: var(--color-blanco) !important;
	}
	.fuente-boton:hover {
		background-color: var(--color-blanco) !important;
		border-color: var(--color-amarillo) !important;
		color: var(--color-amarillo) !important;
	}
	.fondo-modal {
		background-color: var(--color-gris-dark) !important;
	}
	.fuente-titulo-modal {
		font-weight: 600;
		color: var(--color-blanco) !important;
		font-style: italic;
	}
	.fuente-texto-modal {
		font-family: "Open Sans", sans-serif;
		color: var(--color-blanco) !important;
	}
	.fuente-label-modal {
		font-family: "Open Sans", sans-serif;
		color: var(--color-blanco) !important;
	}
	.fuente-caja-modal {
		font-family: "Open Sans", sans-serif;
		/*color: var(--color-azul) !important;*/
	}
	.fuente-boton-modal {
		background-color: var(--color-gris-dark) !important;
		border-color: var(--color-blanco) !important;
	}
	.fuente-boton-modal:hover {
		background-color: var(--color-blanco) !important;
		color: var(--color-gris-dark) !important;
		border-color: var(--color-gris-dark) !important;
	}

	/* xs */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (max-width: 575px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 14px !important;
		}
		.fondo-formulario {
			width: 270px;
		}
		.fuente-boton {
			font-size: 14px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 14px !important;
		}
		.fuente-label-modal {
			font-size: 14px !important;
		}
		.fuente-caja-modal {
			font-size: 14px !important;
		}
		.fuente-boton-modal {
			font-size: 14px !important;
		}
	}

	/* sm */
	/* Estos estilos solo se aplicaran hasta el tamaño indicado */
	@media screen and (min-width: 576px) and (max-width: 767px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 16px !important;
		}
		.fondo-formulario {
			width: 350px;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 16px !important;
		}
		.fuente-label-modal {
			font-size: 16px !important;
		}
		.fuente-caja-modal {
			font-size: 16px !important;
		}
		.fuente-boton-modal {
			font-size: 16px !important;
		}
	}

	/* md */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 768px) and (max-width: 991px) {
		.fuente-titulo1 {
			font-size: 20px !important;
		}
		.fuente-titulo2 {
			font-size: 20px !important;
		}
		.fuente-titulo3 {
			font-size: 16px !important;
		}
		.fondo-formulario {
			width: 310px;
		}
		.fuente-boton {
			font-size: 16px !important;
		}
		.fuente-titulo-modal {
			font-size: 20px !important;
		}
		.fuente-texto-modal {
			font-size: 16px !important;
		}
		.fuente-label-modal {
			font-size: 16px !important;
		}
		.fuente-caja-modal {
			font-size: 16px !important;
		}
		.fuente-boton-modal {
			font-size: 16px !important;
		}
	}

	/* lg */
	/* Solo se aplicaran entre los tamaños indicados */
	@media screen and (min-width: 992px) and (max-width: 1199px) {
		.fuente-titulo1 {
			font-size: 28px !important;
		}
		.fuente-titulo2 {
			font-size: 28px !important;
		}
		.fuente-titulo3 {
			font-size: 18px !important;
		}
		.fondo-formulario {
			width: 400px;
		}
		.fuente-boton {
			font-size: 18px !important;
		}
		.fuente-titulo-modal {
			font-size: 28px !important;
		}
		.fuente-texto-modal {
			font-size: 18px !important;
		}
		.fuente-label-modal {
			font-size: 18px !important;
		}
		.fuente-caja-modal {
			font-size: 18px !important;
		}
		.fuente-boton-modal {
			font-size: 18px !important;
		}
	}

	/* xl */
	/* Los estilos aqui contenidos solo se aplicaran a partir del tamaño de pantalla indicado */
	@media screen and (min-width: 1200px) {
		.fuente-titulo1 {
			font-size: 41px !important;
		}
		.fuente-titulo2 {
			font-size: 41px !important;
		}
		.fuente-titulo3 {
			font-size: 20px !important;
		}
		.fondo-formulario {
			width: 550px;
		}
		.fuente-boton {
			font-size: 20px !important;
		}
		.fuente-titulo-modal {
			font-size: 41px !important;
		}
		.fuente-texto-modal {
			font-size: 20px !important;
		}
		.fuente-label-modal {
			font-size: 20px !important;
		}
		.fuente-caja-modal {
			font-size: 20px !important;
		}
		.fuente-boton-modal {
			font-size: 20px !important;
		}
	}
</style>